import * as fromTemporaries from "../../temporaries/temporariesReducer"
/**
 * Return the refund ID
 * @param {*} state
 */
export const getDetailsRefundId = state => fromTemporaries.getDetailsRefundId(state.temporaries)
